//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { jurisdiction } from "@/api/portrayal/policy"; // import {jurisdictionS } from '@/api/portrayal/studentFile'

export default {
  name: "fileJurisModal",
  props: {
    jurisData: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      treeLoging: false,
      treeData: [],
      defaultProps: {
        children: "children",
        label: "name"
      }
    };
  },
  methods: {
    getTreeData: function getTreeData(id) {
      var _this = this;

      this.treeLoging = true;
      jurisdiction(id).then(function (res) {
        _this.treeLoging = false;
        _this.treeData = res.data.data;
      });
    },
    //   getTreeDataS(id){
    //       this.treeLoging = true
    //       jurisdictionS(id).then(res => {
    //           this.treeLoging = false
    //           this.treeData = res.data.data
    //       })
    //   },
    closeModal: function closeModal() {
      this.$emit("closeJuris", false);
    }
  }
};